import React from 'react';
import DownArrow from '../components/downArrow';

export default class HomeFive extends React.Component {

	render(){
		return (
			<div id="home_five" className="home_five hide_overflow">
				<div className="container">
					
					<div className="home_five_header">
						<h1>
						Select a portfolio that best suits your investment
						<br/> profile and watch it in action
						</h1>
					</div>
				</div>
				<DownArrow elementId="home_five"></DownArrow>
		    </div>
		   
		);
	}
   
}


// WEBPACK FOOTER //
// ./src/js/components/HomeFive.js